import * as React from "react";

import { Route, Switch } from "react-router-dom";

import { App } from "./pages/App";
import NotFound from "./pages/NotFound";
import { OrganizationPage } from "./pages/Organization";
import { OrganizationsPage } from "./pages/Organizations";
import { EnterprisePage } from "./pages/Enterprise";
import { GridPage } from "./pages/Grid";
import { PollPage } from "./pages/Poll";
import { PollsPage } from "./pages/Polls";
import ResumeToken from "./pages/ResumeToken";
import { SubScriptionPage } from "./pages/Subscription";
import { SurveyPage } from "./pages/Survey";
import { SurveysPage } from "./pages/Surveys";
import { TrackPage } from "./pages/Track";
import { TracksPage } from "./pages/Tracks";
import { UserPage } from "./pages/User";
import UserContext from "./pages/UserContext";
import { UsersPage } from "./pages/Users";
import { WorkflowPage } from "./pages/Workflow";
import { WorkflowsPage } from "./pages/Workflows";
import { CampaignsPage } from "./pages/Campaigns";

import { PlatformSubscriptionPage } from "./pages/PlatformSubscription";
import { PlatformSubscriptionsPage } from "./pages/PlatformSubscriptions";
import { PlatformUserPage } from "./pages/PlatformUser";
import { TeamPage } from "./pages/Team";
import { TeamsPage } from "./pages/Teams";

import { SignedInContext } from "./SignedInContext";
import { QandAsPage } from "./pages/QandAs";
import { QandAPage } from "./pages/QandA";
import { TriviasPage } from "./pages/Trivias";
import { TriviaPage } from "./pages/Trivia";
import { ContentQuestionsPage } from "./pages/Content/Questions";
import { ContentCategoriesPage } from "./pages/Content/Categories";
import { ContentQualityPage } from "./pages/Content/Quality";
import { ContentFlaggedPage } from "./pages/Content/Flagged";
import { ContentGeneratePage } from "./pages/Content/Generate";
import { ContentDraftsPage } from "./pages/Content/Drafts";
import { ContentBatchReviewPage } from "./pages/Content/Drafts/BatchReviewPage";
import { ContentReviewEntryPage } from "./pages/Content/Drafts/ReviewEntryPage";

export const PageRoutes = () => {
  const [signedIn, setSignedIn] = React.useState(false);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    if (signedIn) {
      return;
    }
    fetch("/auth/test", {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": "true",
      },
    }).then((response) => {
      if (response.status === 200) {
        setSignedIn(true);
      } else if (response.status === 401) {
        setSignedIn(false);
      } else {
        setError(new Error(`${response.status}: ${response.statusText}`));
      }
    });
  }, [signedIn]);

  if (error) {
    throw error;
  }

  return (
    <SignedInContext.Provider value={{ signedIn, setSignedIn }}>
      {signedIn ? (
        <Switch>
          <Route exact path="/" component={App} />
          <Route path="/campaigns" component={CampaignsPage} />
          <Route path="/usercontext" component={UserContext} />
          <Route path="/users" component={UsersPage} />
          <Route path="/user/:userId" component={UserPage} />
          <Route path="/polls" component={PollsPage} />
          <Route path="/poll/:pollId" component={PollPage} />
          <Route path="/qandas" component={QandAsPage} />
          <Route path="/qna/:qnaId" component={QandAPage} />
          <Route path="/surveys" component={SurveysPage} />
          <Route path="/survey/:surveyId" component={SurveyPage} />
          <Route path="/trivias" component={TriviasPage} />
          <Route path="/trivia/:triviaId" component={TriviaPage} />
          <Route path="/content/questions" component={ContentQuestionsPage} />
          <Route path="/content/categories" component={ContentCategoriesPage} />
          <Route path="/content/quality" component={ContentQualityPage} />
          <Route path="/content/flagged" component={ContentFlaggedPage} />
          <Route path="/content/generate" component={ContentGeneratePage} />
          <Route path="/content/review" component={ContentReviewEntryPage} />
          {/* Before the list route, or `/content/drafts/:batchId` never matches. */}
          <Route
            path="/content/drafts/:batchId"
            component={ContentBatchReviewPage}
          />
          <Route path="/content/drafts" component={ContentDraftsPage} />
          <Route path="/tracks" component={TracksPage} />
          <Route path="/track/:trackId" component={TrackPage} />
          <Route path="/workflows" component={WorkflowsPage} />
          <Route path="/workflow/:workflowId" component={WorkflowPage} />
          <Route
            path="/subscription/:subscriptionId"
            component={SubScriptionPage}
          />
          <Route exact path="/teams" component={TeamsPage} />
          <Route path="/team/:teamId" component={TeamPage} />
          <Route path="/platform-user/:userId" component={PlatformUserPage} />
          <Route
            exact
            path="/platform-subscriptions"
            component={PlatformSubscriptionsPage}
          />
          <Route
            path="/platform-subscription/:subscriptionId"
            component={PlatformSubscriptionPage}
          />
          <Route path="/organizations" component={OrganizationsPage} />
          <Route path="/enterprise" component={EnterprisePage} />
          <Route path="/grid/:gridId" component={GridPage} />
          <Route path="/organization/:orgId" component={OrganizationPage} />
          <Route path="/meteor-resume-tokens" component={ResumeToken} />
          <Route path="*" component={NotFound} />
        </Switch>
      ) : (
        <App />
      )}
    </SignedInContext.Provider>
  );
};
